import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { AngebotStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface AngebotStatusProps {
    disabled?: boolean;
    value: string;
    addAll?: boolean;
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle' };

export const AngebotStatus: React.FC<AngebotStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
    addAll = false,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        if (addAll) {
            list.push(allOption);
        }

        Object.keys(AngebotStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: AngebotStatusLabel[key],
            });
        });

        return list;
    }, [addAll]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: AngebotStatusLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <Select
                name="status"
                isDisabled={disabled}
                value={selectedOption}
                options={options}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '__all__');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
